import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from 'components';
import { FormTileHeader } from './FormTileHeader';
import { FormTileBody } from './FormTileBody';
import { FormTileFooter } from './FormTileFooter';

import './form-tile.scss';

export class FormTile extends React.PureComponent {
  static propTypes = {
    displayImage: PropTypes.bool,
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.arrayOf(PropTypes.node),
    ]),
    isLoaderShow: PropTypes.bool,
    withOverflow: PropTypes.bool,
  };

  static defaultProps = {
    displayImage: true,
    children: null,
    isLoaderShow: false,
    withOverflow: false,
  };

  state = {
    headerFixed: false,
    footerFixed: false,
  };

  onUpdateScroll = (scrollValues /*, prevScrollValues, scrollbar*/) => {
    const { headerFixed, footerFixed } = this.state;

    const {
      scrollTop = 0,
      scrollYPossible,
      clientHeight,
      contentScrollHeight,
    } = scrollValues;

    if (
      !headerFixed &&
      scrollTop > 0 &&
      contentScrollHeight - clientHeight > 50
    ) {
      this.setState({ headerFixed: true });
    } else if (headerFixed && scrollTop === 0) {
      this.setState({ headerFixed: false });
    }

    if (
      !footerFixed &&
      scrollYPossible &&
      contentScrollHeight - clientHeight > 50
    ) {
      this.setState({ footerFixed: true });
    } else if (footerFixed && !scrollYPossible) {
      this.setState({ footerFixed: false });
    }

    // if (prevScrollValues.contentScrollHeight < scrollValues.contentScrollHeight) {
    //   scrollbar.scrollTo(0, scrollValues.contentScrollHeight - prevScrollValues.contentScrollHeight + scrollValues.scrollTop);
    // }
  };

  render() {
    const { headerFixed, footerFixed } = this.state;
    const { children, displayImage, isLoaderShow, withOverflow } = this.props;

    const headerProps = { fixed: headerFixed };
    const bodyProps = { onUpdateScroll: this.onUpdateScroll, withOverflow };
    const footerProps = { fixed: footerFixed };

    return (
      <div className="form-tile">
        <Loader isShow={isLoaderShow}>
          <div className="form-tile__left-panel">
            {React.Children.map(children, (child) => {
              let childProps;
              switch (child.type.displayName) {
                case 'FormTileHeader':
                  childProps = { ...headerProps };
                  break;
                case 'FormTileBody':
                  childProps = { ...bodyProps };
                  break;
                case 'FormTileFooter':
                  childProps = { ...footerProps };
                  break;
                default:
                  childProps = {};
              }
              return React.cloneElement(child, childProps);
            })}
          </div>
        </Loader>
        {displayImage && <div className="form-tile__right-panel" />}
      </div>
    );
  }
}

FormTile.Header = FormTileHeader;
FormTile.Body = FormTileBody;
FormTile.Footer = FormTileFooter;
